import { SEARCH_SUGGESTIONS_LISTBOX_ID } from './constants';
import { getSearchActiveDescendantId } from './get-search-active-descendant-id';

type GetSearchComboboxAriaPropsParams = {
  navigationIndex: number;
  listboxExpanded: boolean;
};

export const getSearchComboboxAriaProps = ({
  navigationIndex,
  listboxExpanded,
}: GetSearchComboboxAriaPropsParams) => ({
  role: 'combobox' as const,
  'aria-controls': SEARCH_SUGGESTIONS_LISTBOX_ID,
  'aria-expanded': listboxExpanded,
  'aria-haspopup': 'listbox' as const,
  'aria-autocomplete': 'both' as const,
  'aria-activedescendant': getSearchActiveDescendantId(navigationIndex),
});
